import React from 'react';
// Import your video file from assets
import ongoingWorkVideo from '../assets/VAJRAM2.mp4';

const VajramVideo = () => {
  return (
    /* Removed min-h-screen and scaled vertical padding so there is no empty gap below the video */
    <section className="bg-gray-100 py-8 sm:py-12 md:py-14 px-3 sm:px-6 lg:px-8">
      {/* Centered container with max-width to look clean from 300px up to 1578px */}
      <div className="w-full max-w-5xl 2xl:max-w-6xl mx-auto">

        {/* Title */}
        <h2 className="text-4xl sm:text-3xl md:text-4xl font-bold text-center text-slate-800 mb-6 md:mb-8">
          Ongoing Work
        </h2>

        {/* The White Card Container */}
        <div className="bg-white p-2.5 sm:p-4 md:p-6 rounded-2xl shadow-lg">
          <div className="overflow-hidden rounded-xl border border-gray-100 bg-black flex items-center justify-center">
            <video
              className="w-full h-auto max-h-[75vh] object-contain block leading-none"
              controls
              muted
              autoPlay
              loop
              playsInline
            >
              <source src={ongoingWorkVideo} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>

      </div>
    </section>
  );
};

export default VajramVideo;